import React from 'react';
import clsx from 'clsx';
import styles from './HorizontalTabs.module.scss';
export const HorizontalTabs = ({ ref, measureOnly, activeTabId, tabs, onTabChange, size })=>/*#__PURE__*/ React.createElement("div", {
        ref: ref,
        className: clsx(styles.horizontalTabs, 'hide-scrollbar', measureOnly && styles.measureOnly)
    }, tabs.map((tab)=>/*#__PURE__*/ React.createElement("div", {
            key: tab.id,
            "data-testid": tab.testId,
            className: clsx(styles.tab, styles[size], 'm-no-drag', activeTabId == tab.id && styles.active),
            onClick: ()=>onTabChange(tab.id)
        }, tab.label)));
